module.exports = "../images/homepage/timer.png";